import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { PATHS } from "util/appConstants";
import Navbar from "components/Navbar";
import LightLayout from "components/Shared/LightLayout";
import { useParams } from "react-router-dom";
import { selectRole, selectRolesStatus,getRoleById, updateRole } from "redux/slices/rolesSlice";
import RoleForm from "components/Roles/form";

const currentAction = "EDIT";
const EditRole = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectRolesStatus);
  const role = useSelector(selectRole);
  const { id } = useParams();
  useEffect(() => {
    if (id && !loading) {
      dispatch(getRoleById(id));
    }
  }, [dispatch, id]);
  
  const onSubmit = async (payload) => {
    await dispatch(updateRole(id, payload)).then((res) =>
      res !== undefined ? history.push(PATHS.admin.roles) : ""
    );
  };
  const transformedRole = {
    ...role,
    permissions: role?.Permissions?.map(p => p.id) || [],
  };
  return (
    <>
      <Navbar />
      <LightLayout doublebar loading={loading || !role}>
        <RoleForm
          action={currentAction}
          initialValues={transformedRole}
          onSubmit={onSubmit}
        />
      </LightLayout>
    </>
  );
};

export default EditRole;
